import * as React from 'react';

import { AB_TEST } from '@abTests';
import { isAbTestEnabled } from '@helpers/utils';
import { noop } from '@utils/noop';

import { useAbTest } from '../../hooks/useAbTest/useAbTest';

import { ImageWrapper, GiftImg } from './styled';

interface IGiftImageThumbProps {
  imageUrl: string;
  formattedImageMessage: string;
  touch: boolean;
  onClick?: () => void;
}

export const GiftImageThumb: React.FC<IGiftImageThumbProps> = ({
  touch,
  imageUrl,
  formattedImageMessage,
  onClick = noop,
}) => {
  const abTestValue = useAbTest();
  const showImageInRowOnMobile = isAbTestEnabled(
    abTestValue,
    AB_TEST.FREE_GIFT_POSITION,
    '1'
  );

  return (
    <ImageWrapper
      touch={touch}
      onClick={onClick}
      showImageInRowOnMobile={showImageInRowOnMobile}
    >
      <GiftImg src={imageUrl} alt={formattedImageMessage} sourceKey="thumb" />
    </ImageWrapper>
  );
};
